<template>
  <div class="page">
    <dashboard-header></dashboard-header>
    
    <div class="content">
      <div class="container-fluid">
        <!-- Page title -->
        <div class="page-header">
          <div class="row align-items-center">
            <div class="col-auto">
              <h2 class="page-title">
                Change your password
              </h2>
            </div>
          </div>
        </div>
      
        <div class="row row-deck row-cards">
          <div class="col-md-12">
            <div class="card">
              <div class="row" v-if="isExpired">
                <h2>You have a generic password set. You must change your password to something more secure. 8 characters minimum.</h2>
              </div>
              
              <div class="row">
                <div class="col-sm-12">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">Current Password</div>
                    </div>
                    <input type="password" class="form-control" placeholder="Current Password" v-model="txtCurrentPass">
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-sm-12">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">New Password</div>
                    </div>
                    <input type="password" class="form-control" placeholder="New Password" v-model="txtNewPass">
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-sm-12">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">New Password (again)</div>
                    </div>
                    <input type="password" class="form-control" placeholder="New Password (again)" v-model="txtNewPass2">
                  </div>
                </div>
              </div>
              
              <div class="row" v-show="!passwordsMatch">
                <div class="col-sm-12">
                  <h2>New passwords do not match!</h2>
                </div>
              </div>
              
              <div class="row" v-show="failMsg.length > 0">
                <div class="col-sm-12">
                  <h2>{{failMsg}}</h2>
                </div>
              </div>
              
              <div class="row">
                <div class="col-sm-12">
                  <button class="btn btn-primary" @click.prevent="onChangePassword">Change Password</button>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
  import DashboardHeader from "./DashboardHeader.vue";
  import DashboardFooter from "./DashboardFooter.vue";
  import WebLLCRESTApi from "../api/api";
  
  export default {
    created() {
      this.api = new WebLLCRESTApi("Users", this.$router);
      this.isExpired = !!JSON.parse(localStorage.getItem('user')).expiredPass;
    },
    
    computed: {
      passwordsMatch() {
        return this.txtNewPass == this.txtNewPass2;
      }
    },
    
    data() {
      return {
        isExpired: false,
        txtCurrentPass: "",
        txtNewPass: "",
        txtNewPass2: "",
        failMsg: ""
      };
    },
    
    methods: {
      async onChangePassword() {
        if(this.passwordsMatch) {
          var postBody = JSON.stringify({
            "oldPassword": this.txtCurrentPass,
            "newPassword": this.txtNewPass,
            "newPasswordConfirm": this.txtNewPass2
          });
          
          var res = await this.api.remoteMethod("changepass", postBody, false);
          
          if(res.status == 200) {
            this.failMsg = "Password changed.";
            this.isExpired = false;
            
            const userData = JSON.parse(localStorage.getItem('user'));
            userData.expiredPass = false;
            localStorage.setItem('user', JSON.stringify(userData));
          }
          else {
            this.failMsg = "Failed to update the password. Was the current password correct?";
          }
        }
      }
    },
    
    components: {
      DashboardHeader,
      DashboardFooter
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue